@use '../../styling/colors.scss' as *;
@use '../../styling/form-controls.scss' as *;

.StopButton {
  background: none;
  color: $color-grey-B;
  cursor: pointer;
  padding: 0;
  border: 0;
  outline: none;

  path {
    fill: currentcolor;
  }

  &:hover,
  &:focus {
    path {
      fill: $color-primary-red;
    }
  }
}

.StopButtonWithText {
  @extend %form-control-font;

  display: inline-flex;
  padding: 7px 12px;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid $theme-color-secondary-button-border;
  background: $theme-color-background;
  color: $color-primary-red;
  column-gap: 8px;

  > svg {
    display: inline-flex;
    align-self: center;
  }

  &:hover {
    background: $theme-color-secondary-button-hover;
  }

  &:active {
    outline: none;
    background: $theme-color-button-delete-active-background;
  }
}
